import Api from '@/services/Api'

// Zatvaranje otvorenih stavaka - veze izmedju racuna i uplata.
// Glavna knjiga se ne mijenja; veze stoje u zasebnoj tablici.
export default {

  // Cijelo stanje saldakonta - svaki dokument s otvorenim i zatvorenim dijelom.
  stanje (query) {
    return Api().get('zatvaranja/stanje', {params: query})
  },

  // Samo nepovezano, uz sazetak po partneru. Jedan popis za sve partnere.
  nepovezane (query) {
    return Api().get('zatvaranja/nepovezane', {params: query})
  },

  // Automatski prijedlozi povezivanja. Nista ne upisuje.
  prijedlozi (query) {
    return Api().get('zatvaranja/prijedlozi', {params: query})
  },

  // Jedan redak po partneru: otvoreni racuni, nepovezane uplate, saldo, dospjelo.
  otvorenePartneri (query) {
    return Api().get('zatvaranja/otvorenepartneri', {params: query})
  },

  // Cime je pojedini dokument zatvoren.
  veze (query) {
    return Api().get('zatvaranja/veze', {params: query})
  },

  // {CompanyId, veze: [{racunId, uplataId, iznos}], izvor, UserId, email}
  // Iznos je neobavezan - bez njega se zatvara koliko god je moguce.
  povezi (podaci) {
    return Api().post('zatvaranja/povezi', podaci)
  },

  odvezi (zatvaranjeId) {
    return Api().delete(`zatvaranja/${zatvaranjeId}`)
  }
}
